// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__2VIV2","list":"BalanceDue_list__b9kt5","listRow":"BalanceDue_listRow__3qGSH","total":"BalanceDue_total__2hzqw"};